import api from "data/APIs";
import { dataProvider } from "data";

/**
 * Searches HSN codes via dataProvider lookup.
 * @param {string} value - Search query value.
 * @returns {Promise<Array>} List of HSN codes.
 */
export const searchHSNCode = async (value) => {
  if (value && value.trim()) {
    const strings = value.split(" - ");
    const searchParams = strings[0] || value;
    try {
      const response = await dataProvider.custom_request(
        `${api.get_hsn_data}?search=${searchParams}`,
        "GET"
      );
      return response?.data?.hsn_codes || [];
    } catch (err) {
      return [];
    }
  }
  return [];
};

/**
 * Returns structured HSN and GST fields for state updates.
 * @param {Object} hsnOption - The selected HSN option object.
 * @param {boolean} useServicePrefix - If true, uses 'service_hsn' and 'service_gst_percentage' keys.
 * @param {boolean} isNumericGst - If true, returns GST as a number rather than string.
 * @returns {Object} Mapped fields.
 */
export const getMappedHsnFields = (
  hsnOption,
  useServicePrefix = false,
  isNumericGst = false
) => {
  const hsnKey = useServicePrefix ? "service_hsn" : "hsnCode";
  const gstKey = useServicePrefix ? "service_gst_percentage" : "gstPercentage";

  return {
    [hsnKey]: hsnOption?.hsn_code || "",
    [gstKey]:
      hsnOption?.gst_percentage != null
        ? isNumericGst
          ? Number(hsnOption.gst_percentage)
          : String(hsnOption.gst_percentage)
        : isNumericGst
        ? 0
        : "",
  };
};
